import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import GeneralForm from './GeneralForm';
import Notification, { notify } from '../../../common/Notification/Notification';

storiesOf('Advanced Search/Initial Forms/Civil/General', module)
  .add('View', () => (
    <div className="advanced-search-form">
      <GeneralForm onSubmit={action('searchGeneral')} onReset={action('resetGeneralSearch')} />
    </div>
  ))
  .add('Search error', () => (
    <div>
      <Notification />
      <GeneralForm
        onSubmit={(...args) => {
          notify.error('Failed to return Advanced Search results');
          action('searchGeneral')(...args);
        }}
        onReset={action('resetGeneralSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/civil/GeneralForm.stories.jsx